import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useCardDetailsStore } from '@lib/store';
import { FormatUtils, PaletteUtils } from '@shared/utils';
import { type CardsEntity, type AccountEntity } from '@shared/api';
import { getUrl } from './accountsSelect';
import { CardImage } from '@widgets';
import { LocalImage } from '@shared/widgets';

interface ItemProps {
  account: AccountEntity;
  card?: CardsEntity | null;
  isMobile?: boolean;
  isActive?: boolean;
}

export const Item = (props: ItemProps) => {
  const cardDetailsStore = useCardDetailsStore();
  return (
    <Link
      className='p-5 h-[140px] flex flex-col flex-wrap justify-center content-start max-[840px]:flex-nowrap max-[840px]:h-auto max-[840px]:p-0 max-[840px]:pb-6 max-[840px]:mx-2'
      to={getUrl(props.account)}
    >
      {props.card ? (
        <CardImage
          className={clsx('text-[3.2vw] rounded max-[840px]:order-2', !PaletteUtils.isBordierPalette && 'shadow-[5px_5px_10px_0_rgba(0,0,0,0.26)]')}
          dark={props.account.product.isDarkCardColor}
          image={props.account.product.cardImageUrl || props.card.cardDesignImageUrl}
          cardHolder={props.card.cardHolder}
          number={FormatUtils.formatCardNumber(props.card.number)}
          validThru={FormatUtils.formatValidThru(cardDetailsStore.data?.expiryDate)}
        />
      ) : (
        <LocalImage
          className={clsx(
            'text-[3.2vw] h-full mr-4 rounded max-[840px]:order-2',
            !PaletteUtils.isBordierPalette && 'shadow-[5px_5px_10px_0_rgba(0,0,0,0.26)]',
          )}
          src={props.account.product?.cardImageUrl}
        />
      )}
      <span
        className={clsx(
          'uppercase mb-1 max-w-[135px] overflow-hidden text-ellipsis whitespace-nowrap max-[840px]:order-1 max-[840px]:text-xl max-[840px]:my-2.5 max-[840px]:mx-auto font-medium',
          PaletteUtils.isBordierPalette ? 'text-[13px] text-black max-[840px]:text-[#dc291c]' : 'text-sm  text-[#cbcaca] max-[840px]:text-[#e5c496]',
          props.isActive && PaletteUtils.isBordierPalette && 'text-white',
        )}
        title={props.account.product?.name}
      >
        {props.account.product?.name}
      </span>
      <span
        className={clsx(
          'uppercase mb-1 max-w-[135px] overflow-hidden text-ellipsis whitespace-nowrap max-[840px]:order-1  max-[840px]:text-xl max-[840px]:my-2.5 max-[840px]:mx-auto max-[840px]:max-w-none font-medium',
          PaletteUtils.isBordierPalette ? 'text-[13px] text-black max-[840px]:text-[#dc291c]' : 'text-sm  text-[#cbcaca] max-[840px]:text-[#e5c496]',
          props.isActive && PaletteUtils.isBordierPalette && 'text-white',
        )}
        title={props.account.displayName}
      >
        {props.account.displayName}
      </span>
      <span
        className={clsx(
          'max-[840px]:hidden',
          PaletteUtils.isBordierPalette ? 'text-[13px] font-black text-[#dc291c]' : 'text-sm font-medium text-[#cbcaca]',
          props.isActive && PaletteUtils.isBordierPalette && 'text-white',
        )}
      >
        {props.account.availableToSpend} {props.account.currency}
      </span>
    </Link>
  );
};
